<div class="overlay" *ngIf="isLoading" [@splash]>
    <section class="container v-center">
      <img src="/assets/media/svg/loading.svg" />
    </section>
</div>
  